import {createIcon, Svg} from "@gluestack-ui/icon";
import {Path} from "react-native-svg";

const ReportsIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        d="M11.6668 1.89258V5.3347C11.6668 5.80141 11.6668 6.03476 11.7577 6.21302C11.8376 6.36982 11.965 6.49731 12.1218 6.5772C12.3001 6.66803 12.5335 6.66803 13.0002 6.66803H16.4423M7.50016 12.5013L10.0002 15.0013M10.0002 15.0013L12.5002 12.5013M10.0002 15.0013L10.0002 10.0013M11.6668 1.66797H7.3335C5.93336 1.66797 5.2333 1.66797 4.69852 1.94045C4.22811 2.18014 3.84566 2.56259 3.60598 3.03299C3.3335 3.56777 3.3335 4.26784 3.3335 5.66797V14.3346C3.3335 15.7348 3.3335 16.4348 3.60598 16.9696C3.84566 17.44 4.22811 17.8225 4.69852 18.0622C5.2333 18.3346 5.93336 18.3346 7.3335 18.3346H12.6668C14.067 18.3346 14.767 18.3346 15.3018 18.0622C15.7722 17.8225 16.1547 17.44 16.3943 16.9696C16.6668 16.4348 16.6668 15.7348 16.6668 14.3346V6.66797L11.6668 1.66797Z"
        stroke="primary-500"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </>
  ),
});

export { ReportsIcon };
